// extracted by mini-css-extract-plugin
export var copyableItem = "_p-0";
export var underlined = "_p-1";